import { render } from "./EmailIcon.svg?vue&type=template&id=0427512c"
const script = {}
script.render = render

export default script